import { profiles, prefectures } from '@/externals/gyym/user'
import {
  UserId,
  UpdateProfileParams,
  Options,
  EmailDeliveryOptions,
} from './types'

export const getMyProfile = async () => {
  return await profiles.me()
}

export const updateProfile = async (
  userId: UserId,
  params: UpdateProfileParams
) => {
  return await profiles.update(userId, params)
}

export const listPrefectureOptions = async (): Promise<Options> => {
  const list = await prefectures.list()
  return list.map((p) => ({ text: p.name, value: p.name }))
}

export const getEmailDeliveryOptions = async () => {
  return await profiles.getEmailDeliveryOptions()
}

export const updateEmailDeliveryOptions = async (
  options: EmailDeliveryOptions
) => {
  return await profiles.updateEmailDeliveryOptions(options)
}
